import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button, Container, Grid, Icon, Message } from 'semantic-ui-react'
import { FaTh } from 'react-icons/fa'
import { useEditHandleError } from '../../Common/Hooks/useEditHandleError'
import {
  loadSubgenreById,
  newSubgenre,
  saveSubgenre,
  updateState
} from '../Slice/SubgenreSlice'
import SubgenreForm from '../Form/SubgenreForm'
import './css/SubgenreListPage.css'

export default function SubgenreEditPage () {
  const { t } = useTranslation()
  const {
    isLoading,
    isSuccess,
    isError,
    message
  } = useSelector((state) => state.subgenre)
  const dispatch = useDispatch()
  const { subgenreId } = useParams()
  const [errorList, goBack, handleError] = useEditHandleError('/subgenre')

  useEffect(() => {
    if (subgenreId === 'new') {
      dispatch(newSubgenre())
    } else {
      dispatch(loadSubgenreById(subgenreId))
    }
  }, [])

  useEffect(() => {
    handleError(isSuccess, isError, message)
    dispatch(updateState())
  }, [isSuccess, isError, message])

  const onSaveSubgenre = () => {
    dispatch(saveSubgenre())
  }

  return (
    <Container className='subgenre-list-page'>
      <div className="subgenre-title subgenre-division">
        <Grid columns={2}>
          <Grid.Column>
            <Icon size='large'><FaTh /></Icon>
            {
              subgenreId === 'new'
                ? (<span>{ t('subgenre.new') }</span>)
                : (<>
                  <span>{ t('subgenre.edit') }</span>
                  <small className='mx-3'># { subgenreId }</small>
                </>)
            }
          </Grid.Column>
          <Grid.Column textAlign='right'>
            <Button
              icon
              labelPosition='left'
              color='grey'
              size='large'
              disabled={isLoading}
              onClick={goBack}>
              <Icon name='arrow circle left' /> { t('generic.goBack') }
            </Button>
            <Button
              icon
              labelPosition='left'
              color='green'
              size='large'
              disabled={isLoading}
              onClick={onSaveSubgenre}>
              <Icon name='save' /> { t('generic.save') }
            </Button>
          </Grid.Column>
        </Grid>
      </div>
      <div className="p-4">
        <SubgenreForm />
      </div>
      <div className="p-4">
        { errorList.length > 0 &&
          <Message error icon='exclamation triangle'
                   header={ t('generic.validation.onSave') }
                   list={errorList} />
        }
      </div>
    </Container>
  )
}
